import Form from './Form';

export { default as initialValues } from './initialValues';
export { default as formValidate } from './formValidate';

export default Form;
